import React from "react";
import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { DragAndDrop } from "@common/dragAndDrop";
import { Node } from "./node";
import { Props } from "./types";
import styles from "./styles.scss";

const ROOT_KEY = "";

function Tree({ organizationalUnits, columns }: Props) {
  const childrenByParent = React.useMemo(() => {
    const map = new Map<string, Identifiable<OrganizationalUnit>[]>();

    organizationalUnits.forEach((organizationalUnit) => {
      const key = organizationalUnit.parentUuid ?? ROOT_KEY;
      map.set(key, [...(map.get(key) ?? []), organizationalUnit]);
    });

    return map;
  }, [organizationalUnits]);

  const roots = childrenByParent.get(ROOT_KEY) ?? [];

  return (
    <DragAndDrop>
      <ul className={styles.tree}>
        {roots.map((organizationalUnit) => (
          <Node
            key={organizationalUnit.uuid}
            organizationalUnit={organizationalUnit}
            depth={0}
            ancestorUuids={[]}
            childrenByParent={childrenByParent}
            columns={columns}
          />
        ))}
      </ul>
    </DragAndDrop>
  );
}

export { Tree };
